import { mainSiteUrl } from '@/mocks/categories';
import { homeContent } from '@/mocks/content';

export default function CtaSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="rounded-3xl overflow-hidden relative">
          <div className="aspect-[21/9] md:aspect-[21/7] w-full overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20product%20photography%20of%20carefully%20arranged%20organized%20fashion%20packages%20wrapped%20in%20kraft%20paper%20with%20twine%20on%20light%20wood%20surface%20soft%20natural%20backlight%20creating%20a%20cozy%20atmosphere%20clean%20aesthetic%20calm%20commercial%20photography%20gentle%20tones&width=1600&height=600&seq=cta-banner-v2-unique&orientation=landscape"
              alt="YOYBUY warehouse"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent"></div>
          </div>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              {homeContent.ctaTitle}{' '}
              <em className="font-light text-foreground-500 not-italic">{homeContent.ctaHighlight}</em>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8 md:mb-10">
              {homeContent.ctaSubtitle}
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-foreground-950 text-background-50 text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
              >
                {homeContent.heroCta1}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-accent-500 text-background-50 text-sm md:text-base font-semibold hover:bg-accent-600 transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
              >
                {homeContent.heroCta2}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shopping-bag-line"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}